<template>
    <div id="directory-hub-banner">
        <img src="/wp-content/plugins/isigma-members/img/laptop.png" />
        <h5>Want to view these searches on a map? Go to our Directory Hub.</h5>
        <a :href="locatorPageUrl" class="isigma_members_btn isigma_members_btn-black">
            Go to Directory Hub
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        locatorPageUrl () {
            return window.LOCATOR_PAGE_URL
        }
    }
}
</script>

<style scoped>
#directory-hub-banner {
    border-radius: 14px;
    background: #FFF;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    padding: 40px 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#directory-hub-banner img {
    max-width: 431.407px;
    width: 100%;
}

#directory-hub-banner h5 {
    color: #000;
    text-align: center;
    font-family: Arial;
    font-size: 22px;
    font-weight: 700;
    margin: 12px 0 25px 0;
}
</style>